import React from "react";
import RankInsignia from "../../../shared/rating/RankInsignia";
import { TIERS, insigniaForValue, bandOf } from "../../../shared/rating/tiers";
import modal from "../match-end/MatchEndModal.module.scss";
import styles from "./ResultBoxes.module.scss";

// "Your rating" box on the Full Results screen: the Match End modal's climb
// card, settled. Same markup and the SAME stylesheet as the modal's card (badge
// slot, tier-coloured delta, big number, the square bar, the "Gold I / 62 left"
// caption), just with no animation: it shows where you stand now, the way the
// modal left it.

interface Props {
  value: number; // display rating after the match
  delta: number; // rating change this match
}

export default function YourRatingCard({ value, delta }: Props) {
  const insignia = insigniaForValue(value);
  const tierColor = insignia.tier.color;
  // The same band maths as the modal: fill within the sub-band, "N left" to its top.
  const band = bandOf(value);
  const atApex = insignia.tier.id === TIERS[TIERS.length - 1].id;
  const fill = atApex ? 1 : Math.max(0, Math.min(1, (value - band.low) / band.width));
  return (
    <div className={`${modal.card} ${styles.ratingCard}`} style={{ "--tier": tierColor } as React.CSSProperties}>
      <h4>Your rating</h4>
      <div className={modal.climb}>
        <span className={modal.badgeSlot}>
          <RankInsignia value={value} size={84} />
        </span>
        <span className={modal.delta} style={{ color: tierColor }}>
          {delta >= 0 ? "+" + delta : String(delta)}
        </span>
        <span className={modal.ratingLine}>
          <span className={modal.ratingNum}>{value}</span>
        </span>
      </div>
      <div className={modal.bar}>
        <i style={{ transform: `scaleX(${fill})` }} />
      </div>
      <div className={modal.barCap}>
        <span className={`${modal.capTier} ${modal.capShow}`}>{insignia.label}</span>
        <span className={`${modal.capProgress} ${modal.capShow}`}>{atApex ? "MAX" : `${band.low + band.width - value} left`}</span>
      </div>
    </div>
  );
}
